var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switch",on:{"click":_vm.toggleLanguage}},[_c('img',{staticClass:"language-icon",style:({ width: '25px', height: '18px' }),attrs:{"src":require("@/assets/home/language.svg"),"alt":"language"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }